import React from "react";
import { ScanEye, Zap } from "lucide-react";
import { InspectorVisibilityEyeButton } from "../components/ui/InspectorVisibilityEyeButton";
import { InspectorVisibilitySection } from "../components/property-panels/InspectorVisibilitySection";
import VisibilityIconRow from "../components/property-panels/VisibilityIconRow";
import { useConstraintVisibilityControls } from "./useConstraintVisibilityControls";
import { useViewerActions, useViewerStore } from "../stores/viewerStore";

const TendonVisibilityToolbar = ({
  tendonUuid,
  className = "",
  sectionTitle = "Tendon Visibility",
}) => {
  const tendonMarkerVisibility = useViewerStore((s) => s.tendonMarkerVisibility);
  const showActuators = useViewerStore((s) => s.showActuators);
  const viewerActions = useViewerActions();
  const thisTendonMarkersVisible = tendonUuid ? tendonMarkerVisibility[tendonUuid] !== false : true;

  const { state, focusDisabled, toggleFocus } = useConstraintVisibilityControls({
    tendonUuid: tendonUuid ?? null,
    enabled: Boolean(tendonUuid),
  });

  return (
    <InspectorVisibilitySection
      sectionTitle={sectionTitle}
      className={className}
      headerActions={
        <div className="flex items-center gap-1">
          <InspectorVisibilityEyeButton
            visible={thisTendonMarkersVisible}
            onToggle={() =>
              tendonUuid &&
              viewerActions.setTendonMarkerVisibility(tendonUuid, !thisTendonMarkersVisible)
            }
            tooltipWhenOn="This tendon's markers are visible (N) — click to hide"
            tooltipWhenOff="This tendon's markers are hidden (N) — click to show"
            ariaLabel="Toggle this tendon marker visibility"
          />
          <InspectorVisibilityEyeButton
            visible={showActuators}
            onToggle={() => viewerActions.toggleShowActuators()}
            tooltipWhenOn="Actuator visibility is on"
            tooltipWhenOff="Actuator visibility is off"
            ariaLabel="Toggle actuator visibility"
            Icon={Zap}
          />
        </div>
      }
    >
      <VisibilityIconRow
        actions={[
          {
            key: "focus",
            title: "Display selected tendon only",
            on: state.focus,
            onClick: toggleFocus,
            disabled: focusDisabled,
            Icon: ScanEye,
          },
        ]}
      />
    </InspectorVisibilitySection>
  );
};

export default React.memo(TendonVisibilityToolbar);
